export default "__VITE_ASSET__6cvnNCq5__"